import React, {FunctionComponent} from "react";

const styles = require('./articleLayout.module.scss');
import {trimString, WordpressPost} from "../../interfaces/wordpressPost.interface";
import {Article, ArticleView, BlogTitleLink, Divider} from "@klear/open-site";

const smallExcerptLength = 100;

interface ArticleLayoutProps {
    isHorizontal: boolean,
    sectionIcon: string,
    mainTitle: string,
    sideTitle: string,
    posts: Array<{ node: WordpressPost }>,
    featured: WordpressPost
}


export const ArticleLayout: FunctionComponent<ArticleLayoutProps> = ({isHorizontal, sectionIcon, mainTitle, featured, posts, sideTitle}) => {
    return (
        <>
            <div className={styles.container}>
                <BlogTitleLink mainTitle={mainTitle} divider={isHorizontal} sideTitle={sideTitle}
                               sectionIcon={sectionIcon}
                               sideTitleLink={featured.categories[0].slug}/>
                <div className={styles.containerBottom}>
                    <div className={styles.mainArticle}>
                        <a href={`${featured.slug}/`}>
                            <Article mainArticleImage={featured.featured_media?.source_url}
                                         mainArticleTitle={featured.title}
                                         mainArticleDescription={featured.excerpt}
                                         isSmall={false}/>
                        </a>
                        <div className={styles.gotToArticleCont}>
                            <div className={styles.gotToArticle}>
                                <div className={styles.goToIcon}>
                                    <i className='fa fa-arrow-right'/>
                                </div>
                                <div>
                                    Go to Article
                                </div>
                            </div>
                        </div>
                    </div>
                    {!isHorizontal && <Divider direction={"vertical"}/>}
                    <div className={styles.secondaryArticles}>
                        <div className={styles.smallTitle}>More Articles</div>
                        <Divider className={styles.showOnMobile} direction={"horizontal"}/>
                        {posts.map(({node}) => (
                            <a href={`${node.slug}/`}>
                                <ArticleView articleTitle={node.title} articleDescription={trimString(node.excerpt,smallExcerptLength)}
                                             animation={true} />
                            </a>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    )
};